import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    TextButton,
    Text,
    LabeledControl,
    Label,
    Checkbox,
    Button,
    Spacer,
} from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';
import UserManagementActions from 'app/shared/actions/UserManagementActions';

import './style.scss';

const propTypes = {
    onNextStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const Questions = ({
    currentUser,
    onNextStep,
    onCancel,
    dispatch,
    onBack,
}) => {
    const allProperties = currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES];
    const hasProperties = currentUser.properties.length > 0;
    const [hasLimitedProperties, setHasLimitedProperties] = React.useState(!allProperties && hasProperties);

    const handleSetSyncProperties = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]: true,
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
        setHasLimitedProperties(false);
    };

    const handleSetLimitedProperties = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]: false,
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
        setHasLimitedProperties(true);
    };

    return (
        <div>
            <Spacer marginY="sm">
                <Text>Grant Property Access</Text>
            </Spacer>
            <Spacer marginBottom="sm">
                <Text>
                    {`Do you want ${currentUser.userName} to have access to all
                    properties or selected properties?`}
                </Text>
            </Spacer>
            <LabeledControl
                label={(
                    <Label>
                        All properties - This will automatically include any properties added in the future
                    </Label>
                )}
                control={(
                    <Checkbox
                        checked={currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]}
                        onChange={handleSetSyncProperties}
                    />
                )}
            />
            <LabeledControl
                label={(
                    <Label>
                        Selected properties - You&apos;ll choose which properties
                        {` ${currentUser.userName} `}
                        can access.
                        Access to future properties must be granted manually
                    </Label>
                )}
                control={(
                    <Checkbox
                        checked={hasLimitedProperties}
                        onChange={handleSetLimitedProperties}
                    />
                )}
            />
            <HR />
            <div className="Questions-footer">
                <TextButton className="Questions-button" onClick={onCancel}>
                    Cancel
                </TextButton>
                <div>
                    <TextButton className="Questions-button" onClick={onBack}>
                        Back
                    </TextButton>
                    <Button
                        buttonType="primary"
                        onClick={onNextStep}
                        disabled={!(currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]
                            || hasLimitedProperties)}
                    >
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    currentUser: state.userManagement.currentUser,
});

Questions.propTypes = propTypes;

export default connect(mapStateToProps)(Questions);
